import { useState } from 'react';
import { Container } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import DataDisplay from './UsersDataDisplay';
import Resources from './Resources';

function TaskFeaturesTab() {
  const [key, setKey] = useState('users');

  return (
    <Container style={{marginTop:"20px"}}>
    <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={(k) => setKey(k)}
      className="mb-3"
    >
      <Tab eventKey="users" title="Users">
       <DataDisplay/>
      </Tab>
      <Tab eventKey="resources" title="Resources">
        <Resources/>
      </Tab>
      <Tab eventKey="contact" title="Contact" disabled>
        Tab content for Contact
      </Tab>
    </Tabs>
    </Container>
  );
}

export default TaskFeaturesTab;